import { render, staticRenderFns } from "./ResetUserLog.vue?vue&type=template&id=f8893bd8&lang=pug&"
import script from "./ResetUserLog.vue?vue&type=script&lang=ts&"
export * from "./ResetUserLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports